// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "inc.tomo",
    name: "tomo extension wallet",
    homepage: "https://tomo.inc",
    image_id: "27e33ac7-b846-446d-a126-b0820904f800",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/tomo-inc/id6468010287",
        android: "https://play.google.com/store/apps/details?id=tomo.app.unyx",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chromewebstore.google.com/detail/tomo-wallet/pfccjkejcgoppjnllalolplgogenfojk",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "inc.tomo",
    mobile: {
        native: null,
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map